import './sign-out-button.scss';

import { Icon } from 'components/icon/Icon';
import { BaseButton } from '../button-base';
import { ButtonProps, Menu } from 'antd';
import { useSignOut } from './useSignOut';

interface SignOutButtonProps {
  label?: string;
  rounded?: boolean;
  buttonType?: ButtonProps['type'];
}

export function SignOutButton(props: SignOutButtonProps) {
  const { label = 'Log Out' } = props;
  const { onClick } = useSignOut();

  return (
    <BaseButton
      onClick={onClick}
      style={{ paddingLeft: '4rem', paddingRight: '4rem' }}
      icon={<Icon size="sm">login</Icon>}
      iconPosition={'start'}
      type={props.buttonType}
    >
      <span>{label}</span>
    </BaseButton>
  );
}

export function SignOutButtonMenuItem(props: SignOutButtonProps) {
  const { label = 'Log Out' } = props;
  const { onClick } = useSignOut();

  return (
    <Menu.Item
      onClick={onClick}
      icon={<Icon size="sm">logout</Icon>}
      style={{ display: 'flex', alignItems: 'center' }}
    >
      {label}
    </Menu.Item>
  );
}
